import type { AppMode } from '../types';

/**
 * Converts an AppMode and params to a URL path
 */
export function modeToUrl(mode: AppMode, params?: Record<string, any>): string {
  const modeMap: Record<string, string | ((params?: Record<string, any>) => string)> = {
    'dashboard': '/',
    'guides': '/guides',
    'help-centers': '/help-centers',
    'articles': '/articles',
    'portal-settings': '/settings/guides-appearance',
    'add-guide': '/guides/new',
    'edit-guide': (params) => params?.id ? `/guides/${params.id}/edit` : '/guides',
    'edit-article': (params) => params?.articleId ? `/articles/${params.articleId}/edit` : '/articles',
  };

  const urlOrFn = modeMap[mode];
  
  if (typeof urlOrFn === 'function') {
    return urlOrFn(params);
  }
  
  return urlOrFn || '/';
}

